import type {
  AdminOverlayDefinition,
  AdminViewDefinition,
} from "../../components/admin-components.js";
import { card, modal, withModal } from "../_shared/overlay-definition-helpers.js";

export const operationOverlayViews: AdminViewDefinition[] = [
  withModal("enable-kill-switch", "incident-feature-controls", enableKillSwitchModal()),
  withModal("disable-kill-switch", "incident-feature-controls", disableKillSwitchModal()),
];

function enableKillSwitchModal(): AdminOverlayDefinition {
  return modal(
    "Kill-switch controls unavailable",
    [
      card("Current status", [
        "Backend control-plane endpoint is not implemented.",
        "This overlay is manual guidance only and does not change production behavior.",
      ]),
      card("Required backend contract", [
        "Required input - capability, scope, target, expiration, incident or reason.",
        "Required checks - authorization, audit record, merchant-safe notification, rollback path.",
      ]),
    ],
    [{ label: "Close" }],
  );
}

function disableKillSwitchModal(): AdminOverlayDefinition {
  return modal(
    "Automatic offer restoration unavailable",
    [
      card("Current status", [
        "Backend control-plane endpoint is not implemented.",
        "This overlay is manual guidance only and does not change production behavior.",
      ]),
      card("Required backend contract", [
        "Required input - capability, scope, target, expiration, incident or reason.",
        "Required checks - authorization, audit record, merchant-safe notification, rollback path.",
      ]),
    ],
    [{ label: "Close" }],
  );
}
